import BasePage from "components/basePage/BasePage";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserDescriptor } from "services/requests";
import { StandardView } from "wm-standard-crud";

export default function Users() {
  const [descriptor, setDescriptor] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    getUserDescriptor().then((description) => setDescriptor(description));
  }, []);

  return (
    <BasePage title="Usuários">
      <StandardView
        descriptor={descriptor}
        addBtnText={"Novo Termo"}
        addBtn={"add-btn"}
        addNew={() => navigate("/user")}
        onItemClick={({ wuserId }) => navigate(`/user/${wuserId}`)}
      />
    </BasePage>
  );
}
